
import { Component, Vue } from "vue-property-decorator";
import ReGraphicComponent from "../../_home/components/remote_events/re_graphic.component.vue";
@Component({
  name: "re-third-component",
  components: { ReGraphicComponent },
})
export default class ReThirdComponent extends Vue {}
